import React from "react";

import { Typography } from "@mui/material";

export const CatchmentLongDescription = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        Catchment Partnerships seek to improve the health and natural
        functioning of a wide variety of interconnected water environments and
        river systems, putting people and wildlife at their heart, to meet the
        national goal of: ‘improving the environment within a generation and
        leaving it in a better state than we found it‘ (DEFRA 25 Year Plan ){" "}
        <a
          href="https://www.thames21.org.uk/catchment-partnerships/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Thames21
        </a>{" "}
        by the Thames River Basin Management Plan, six of these in Greater
        London. In terms of catchment partnerships hosted, Thames21 is the
        largest River Trust in the river Thames district. Working closely with
        our CaBA host neighbours we also chair the Catchment Partnerships in
        London group to share knowledge and experience; and support
        collaboration and effective coordination amongst CaBA hosts. Data source
        Thames21.
      </Typography>
    </>
  );
};

export const catchmentShortDescription =
  "Click a catchment partnership on the map to view more information.";
